import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLeaf, 
  faFlask, 
  faGlobeAmericas, 
  faMedal,
  faShippingFast
} from '@fortawesome/free-solid-svg-icons';

const TrustBadges: React.FC = () => {
  const badges = [
    { icon: faLeaf, text: '100% NATURAL' },
    { icon: faFlask, text: 'LAB TESTED' },
    { icon: faGlobeAmericas, text: 'ETHICALLY SOURCED' },
    { icon: faMedal, text: 'PREMIUM QUALITY' },
    { icon: faShippingFast, text: 'FAST SHIPPING' }
  ];

  const repeatedBadges = [...badges, ...badges, ...badges, ...badges, ...badges];

  return (
    <div className="bg-gray-100 py-8 overflow-hidden">
      <div className="relative flex overflow-x-hidden">
        <div className="animate-marquee whitespace-nowrap">
          {repeatedBadges.map((badge, index) => (
            <div 
              key={index} 
              className="inline-flex items-center mx-8"
            >
              <FontAwesomeIcon 
                icon={badge.icon} 
                className="text-[#2b603e] text-2xl mr-2" 
              />
              <span className="font-bold">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBadges; 